export const theme = {
  backgroundPrimary: '#fff',
  backgroundDark: '#343434',
  backgroundHighlight: '#fff7c9',
  textPrimary: '#343434',
  textLight: '#fff',
}

const colors = {
  white: '#fff',
  black: '#343434',
  grey: '#292929',
  yellow: '#fff7c9',
  green: '#377285',
  pink: '#fac0f6',
}

export const blackTheme = {
  // background
  backgroundPrimary: colors.white,
  backgroundDark: colors.green,
  backgroundHighlight: colors.yellow,
  // text
  textPrimary: colors.black,
  textLight: colors.white,
  textHighlight: colors.green,
  textReverse: colors.yellow,
  // cursor
  cursorBackground: colors.pink,
  cursorVideoBackground: colors.pink,
  // logo
  logoBackground: colors.green,
  // cookies
  cookiesBannerBackground: colors.grey,
}
